import { AuditLink } from '@optools/components/audit-link';
import { Badge } from '@optools/components/ui/badge';
import { Card } from '@optools/components/ui/card';
import { MediaType } from '@optools/services/operator-gateway/types/generated/graphql';
import { ScheduleContent, ScheduleMedia } from '@optools/services/operator-gateway/types/schedule';
import { Speaker, Video } from 'lucide-react';

export interface AuditMediaDetailProps {
  content: ScheduleContent;
  media: ScheduleMedia;
}

export function AuditMediaDetail({ content, media }: AuditMediaDetailProps) {
  return (
    <Card
      className="grid grid-cols-[80px_1fr_96px_140px_80px] items-center gap-4 rounded-sm p-2 text-xs"
      data-testid={`game-media-${media.id}`}>
      <div className="flex flex-col gap-2">
        <h2 className="text-xs font-semibold">Media Type</h2>
        <Badge variant="secondary">
          {media.mediaType === MediaType.VIDEO ? <Video /> : <Speaker />} {media.mediaType}
        </Badge>
      </div>

      <div className="flex flex-col gap-2">
        <h2 className="font-semibold">Media ID</h2>
        <AuditLink className="whitespace-nowrap" tag="mediaId" value={media.id} />
      </div>

      {content && (
        <>
          <div className="flex flex-col gap-2">
            <h2 className="font-semibold">Call Sign</h2>
            <p className="whitespace-nowrap">{content?.callSign ?? 'N/A'}</p>
          </div>

          <div className="flex flex-col gap-2">
            <h2 className="font-semibold">Content Experience</h2>
            <p>{content?.mediaState?.contentExperience}</p>
          </div>

          <div className="flex flex-col gap-2">
            <h2 className="font-semibold">State</h2>
            <p>{content?.mediaState?.state}</p>
          </div>
        </>
      )}
    </Card>
  );
}
